<!-- 订购确认 -->

<template>
    <div class="package-buy-confrim">
        <app-header
            :title="$t('packages.confirm.title')"
            @on-click="goBack"
        ></app-header>

        <div class="settlement_box" :class="{'payAgreeSymbol_wrap':CheckautopayRegulation.payAgreeSymbol_wrap}">
            <div class="payAgreeSymbol">
                <h2 class="settlement_title" v-text="packageData.goodsName"></h2>
                <p class="sale_Promotion" v-html="CheckautopayRegulation.sale_Promotion"></p>
                <ul class="Sale_Portal">
                    <li class="Easy">
                        <img :src="$NeWDomain.getImgUrl('imgs/packages/easy@2x.png')" alt="easy" />
                        <p>
                            {{$t('settlement_Easy_and_convenient')}}
                        </p>
                    </li>
                    <li class="deal">
                        <img :src="$NeWDomain.getImgUrl('imgs/packages/deal@2x.png')" alt="deal" />
                        <p>{{$t('settlement_Great_deal')}}</p>
                    </li>
                    <li class="Safe">
                        <img :src="$NeWDomain.getImgUrl('imgs/packages/safe@2x.png')" alt="safe" />
                        <p>{{$t('settlement_Safe_and_secure')}}</p>
                    </li>
                </ul>
                <div class="payAgreeSymbol_wrap_agreement">
                    <p>{{$t('settlement_Read')}}  “<a :href="CheckautopayRegulation.url"  target="_blank" >{{$t('settlement_Autopay_service_regulation')}}</a>”</p>
                </div>
            </div>
            <div class="settlement_summary">
                <div class="summary">
                    <div class="inner">
                        <div class="summary_detail none">
                            <div class="summary_item inner_padding">
                                <div class="summary_list mb8">
                                    <p class="package_name" v-text="packageData.goodsName"></p>
                                    <div class="package_num_icon">
                                        <div class="fl"><img :src="$NeWDomain.getImgUrl('imgs/packages/m_del_num.png')"/><span class="package_num">{{urlParams.quantity}}</span></div>
                                        <div class="package_price"><span class="price" v-text="ShowPrice"></span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="summary_item inner_total_padding">
                                <div class="summary_list" :class="{'mb_8':Promotion_detail.PromotionValue}">
                                    <span class="package_subTotal_title">{{$t('settlement_Subtotal')}}</span>
                                    <span class="package_subTotal fr">{{Subtotal}}</span>
                                </div>
                                <div class="summary_list" v-if="Promotion_detail.PromotionValue && Promotion_use">
                                    <span class="package_subTotal_title">{{Promotion_detail.PromotionValue[0].show_Promotion_name || Promotion_actName}}</span>
                                    <span class="package_subTotal fr color_F74E4E" :dir="isCurrencySymbol(packageData.currencyType) ? '' : 'ltr'">{{Promotion_use_discount}}</span>
                                    <p v-if="Module_Coupon && (couponDataList.availableList && couponDataList.availableList.length)" class="color_FFB242">{{$t('settlement_promotion_tip')}}</p>
                                </div>
                            </div>
                           
                        </div>
                        <div class="summary_content bgfff">
                             <div class="summary_item inner_total_padding none border_none border_bottom" v-if="Module_Coupon">
                                <div class="summary_list summary_list_coupon">
                                    <span class="package_coupon_title">{{$t('settlement_Coupon')}}</span>
                                    <span class="coupon_select coupon_num fr" @click.stop="e_openCouponDialog" v-if="!couponSelect">
                                        <label class="coupon_canuse mr10" :class="{'coupon_canuse':couponDataList.availableList.length>0,'coupon_cantuse':couponDataList.availableList.length==0}" v-html="couponDataList.couponText"></label>
                                        
                                        <van-icon :name="$i18n.locale ==='ar-AE' ? 'arrow-left' : 'arrow'" size=".3rem" color="#dbdbdb" class="position_top_icon" />
                                    </span>
                                    <span class="coupon_select fr" v-else><span class="coupon_fee"></span></span>
                                    <!-- 有活动 -->
                                    <!-- 有使用活动 -->
                                    <!-- 选择了优惠券 -->
                                    <p v-if="Promotion_detail.PromotionValue && !Promotion_use && couponDataList.selectedCoupon.promotionCode" class="color_FFB242">{{$t('settlement_coupon_tip')}}</p>
                                </div>
                            </div>
                            <div class="summary_item inner_total_padding border_none">
                                <div class="summary_list ">
                                    <span class="package_subTotal_title">{{$t('settlement_TOTAL')}}</span>
                                    <span class="package_subTotal fr" v-text="packageData.priceStr"></span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="summary_footer bgfff" v-if="CheckautopayRegulation.GeneralPackageHasLxcx_show">
                            <div class="summary_item GeneralPackageHasLxcx" style="display: block;"  >
                                <div class="Contract_recommendation"
                                    v-html="CheckautopayRegulation.Contract_recommendation"
                                    @click="CheckautopayRegulation.goToLxcxPkg" >
                                </div>
                            </div>
                        </div>
                        
                        
                    </div>
                </div>
            </div>
        </div>

        

        <div class="payment-btn cell-box"  @click="onlinePayment">
            <span class="fw600 online-payment">{{ $t('packages.confirm.online_payment') }}</span>
        </div>

        
        
        <van-popup v-model:show="status.showCouponPopup" 
        round closeable position="bottom"
        :overlay-style="{background:'rgba(0, 0, 0, 0.5)'}"
        :close-on-click-overlay="false"
        class="icon_popup"
        >
        <!-- :style="{ 'max-height': '90%' }"> -->
            <com-coupon v-if="status.comCoupon" @closeCoupon="e_hideCouponDialog" :dataList="couponDataList" @chooseCoupon="e_selectCoupon"></com-coupon>
        </van-popup>
        
    </div>
</template>

<script>
    import { Popup } from 'vant';
    import cookie from '@/utils/cookie'
    import {  keepTwodecimalFull } from '../../utils/util'
    import { pay as payFun } from '../pay/pay'
    import autopayRegulation from '@/logic/autopayRegulation';
    import checkProjectConfig from '@/lib/checkProjectConfig';
    import comCoupon from '@/components/com-coupon.vue';
    import AmountHelper from '@/utils/amountHelper'
    import dateUtil from "../../utils/DateUtil";

    const autopayRegulation_url = {
        'zh-CN': 'autopayRegulation_url_zh_cn',
        'zh-TW': 'autopayRegulation_url_zh_tw',
        'en-US': 'autopayRegulation_url_en',
        'tr-TR': 'autopayRegulation_url_tr',
        'ja-JP': 'autopayRegulation_url_ja',
        'vi-VN': 'autopayRegulation_url_vi',
        'th-TH': 'autopayRegulation_url_th',
        'de-DE': 'autopayRegulation_url_de',
        'pt-PT': 'autopayRegulation_url_pt',
        'es-ES': 'autopayRegulation_url_es',
        'fr-FR': 'autopayRegulation_url_fr',
        'it-IT': 'autopayRegulation_url_it',
        'in-ID': 'autopayRegulation_url_in',
        'ru-RU': 'autopayRegulation_url_ru',
        'ar-AE': 'autopayRegulation_url_ar',
        'ko-KR': 'autopayRegulation_url_ko',
        'pl-PL': 'autopayRegulation_url_pl',
        'ms-MY': 'autopayRegulation_url_ms',
        'uz-UZ': 'autopayRegulation_url_uz',
        'nl-NL': 'autopayRegulation_url_nl',
        'sv-SE': 'autopayRegulation_url_sv',
        'fi-FI': 'autopayRegulation_url_fi',
        'da-DK': 'autopayRegulation_url_da',
        'nb-NO': 'autopayRegulation_url_nb',
        'el-GR': 'autopayRegulation_url_el',
        'hu-HU': 'autopayRegulation_url_hu',
        'bg-BG': 'autopayRegulation_url_bg',
        'ro-RO': 'autopayRegulation_url_ro',
        'cs-CZ': 'autopayRegulation_url_cs',
        'sk-SK': 'autopayRegulation_url_sk',
        'sl-SI': 'autopayRegulation_url_sl',
        'sq-AL': 'autopayRegulation_url_sq',
        'hr-HR': 'autopayRegulation_url_hr',
        'lt-LT': 'autopayRegulation_url_lt',
        'lv-LV': 'autopayRegulation_url_lv',
        'et-EE': 'autopayRegulation_url_et',
        'is-IS': 'autopayRegulation_url_is',
        'km-KH': 'autopayRegulation_url_km',
        'lo-LA': 'autopayRegulation_url_lo',
    };

    export default {
        name: 'settlement',
        components: {
           Popup,
           comCoupon,
        },
        data() {
            return {
                CheckautopayRegulation:{
                    GeneralPackageHasLxcx_show:false,
                    url:this.$APP_CONFIG[autopayRegulation_url[cookie.getCookie('langType')]],
                },
                urlParams: {
                    quantity: 1
                },
                goods: {},
                packageData: {},
                Promotion_detail:{},
                Promotion_use:"",
                Promotion_use_discount:"",
                data_info:{},
                couponSelect: false,//选择了促销码（优惠券）
                status:{
                    value:true,
                    showCouponPopup:false,
                    comCoupon:true,//优惠券弹框
                },
                couponDataList:{//优惠券列表数据
                    availableList:[],//可用优惠券列表
                    unavailableList:[],//不可用优惠券列表
                    selectedCoupon:{},//选中的优惠券数据
                    couponText:"",//优惠栏目展示
                    onlyUseBalance:false,//只能使用余额（使用优惠券后金额为0时）
                    publicValid:true,//公共优惠券是否可用
                    publicTips:"",//公共优惠券是否可用提示
                },
                canUseBalance:false,
                Subtotal:'',
                ShowPrice:'',
                Promotion_actName: ''
            }
        },
        computed: {
            Module_Coupon:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_Coupon",false);
            },
        },
        mounted() {
            let currentURL
            this.urlParams = Object.assign({},this.urlParams, this.$route.query);
            let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
            //关联本地方法；
            autopayRegulation.globalPriceFormat = this.globalPriceFormat;
            autopayRegulation.e_preCalcOrder = this.CreateMethodToAutopayRegulation;
            autopayRegulation.getDataAjax = this.getAjax;
            autopayRegulation.$showDialog = this.$dialog;
            autopayRegulation.langType = cookie.getCookie('langType');
            autopayRegulation.createOrder = this.createOrder;
            // autopayRegulation.$toast = this.$toast;
            autopayRegulation.$api = this.$api;
            autopayRegulation.currentIMEI_imei= sessionStorage_UrlData.imei;
            
            currentURL= this.$projectConfig[autopayRegulation_url[cookie.getCookie('langType')]];
            if(currentURL){
                CheckautopayRegulation.url = currentURL;
            }
            //autopayRegulation.$vux = this.$vux;
            try{
                let data_info = JSON.parse(sessionStorage.getItem('data_info'));
                let data_promotion = JSON.parse(sessionStorage.getItem('data_promotion')||0);
                if(data_info){
                    let tempData = data_info.data[data_info.selectPackage]
                    this.initData(JSON.parse(tempData), data_promotion,data_info['isLxcx']);
                }
            }catch(e){}
                
            
                
        },
        methods: {    
            goBack() {
                this.$router.go(-1);
            },     
            initData(tempData,promotionData,isLxcx) {
                //补充价格
                //* --- Subtotal
                // tempData.priceStr = this.doPriceStyle(tempData.currencyType,tempData.goodsPrice);
                let total = AmountHelper.multiply(tempData.goodsPrice, this.urlParams.quantity);
                this.Subtotal =  this.doPriceStyle(tempData.currencyType,total);
                tempData.priceStr = this.doPriceStyle(tempData.currencyType,total);
                tempData.actualPaymentAmount = total;

                // 展示金额修改为销售品金额
                this.ShowPrice = this.doPriceStyle(tempData.currencyType,tempData.goodsPrice);
                this.packageData = tempData;
                autopayRegulation.categoryCode_IS_LXCX(tempData);//判断是否连续畅享
                autopayRegulation.currentGoodsName = tempData.goodsName;
                this.ShowAutopayRegulation();//展示连续畅享
                //是否需要查询优惠码
                if(this.Module_Coupon && !isLxcx){
                    this.e_queryAssociatedPromotion(total,this.$route.query.promotionCode ? false : promotionData);  
                }
                if(promotionData && !isLxcx && !this.$route.query.promotionCode){
                    this.Promotion_detail = promotionData;
                    //从套餐获取最佳优惠券编码
                    this.e_preCalcOrder(false , tempData.promotionActivityCode);
                }
                if(promotionData && !isLxcx && this.$route.query.promotionCode){
                    this.Promotion_detail = promotionData;
                    this.Promotion_use = promotionData?.promotionActivityCode || true;
                }
            },
            ShowAutopayRegulation(){
                this.CheckautopayRegulation.payAgreeSymbol_wrap = autopayRegulation.payAgreeSymbol_wrap;
                this.CheckautopayRegulation.sale_Promotion = autopayRegulation.sale_Promotion;
                this.CheckautopayRegulation.GeneralPackageHasLxcx_show = autopayRegulation.GeneralPackageHasLxcx_show;
                this.CheckautopayRegulation.Contract_recommendation = autopayRegulation.Contract_recommendation;
                this.CheckautopayRegulation.goToLxcxPkg = autopayRegulation.goToLxcxPkg;
            },
            // 查询优惠码
            e_queryAssociatedPromotion(total,promotionData){
                let that = this;
                let params = {
                    "perPageCount":1000,
                    "currentPage":1,
                };
                let selectedCoupon = JSON.parse(sessionStorage.getItem('data-selectedCoupon') || "{}");
                that.$set(that.couponDataList,"availableList",[]);
                that.$set(that.couponDataList,"unavailableList",[]);
                that.$http.post(that.$api.queryPromotionInst, params).then(d => {
                    let data = [];
                    let selectedCouponOp = {};
                    if(d && d.data && d.data.dataList){
                        data =  d.data.dataList
                    }
                     
                    // quota----如果是金额，单位：元，如果是百分比，则在0-100%
                    for(let i in data){
                        data[i].validPeriod = dateUtil.formatDateTime(new Date(data[i].effectiveDate), 'yyyy/MM/dd HH:mm')+" - "+dateUtil.formatDateTime(new Date(data[i].expiryDate), 'yyyy/MM/dd HH:mm');
                        
                        if(data[i].promotionMode=="P01"||data[i].promotionMode=="P03"){//P01：满减百分比;蓝色  P03:直减百分比;绿色
                            data[i].offerLogo = "OFF";
                            data[i].preferentialRatio = data[i].quota+"%";
                        }else if(data[i].promotionMode=="P02"||data[i].promotionMode=="P04"){//-P02:满减金额;橘色  //P04:直减金额;橙色
                            data[i].offerLogo = that.packageData.currencyType;
                            data[i].preferentialRatio = data[i].quota;
                        }
                    }
                    // 可用与不可用优惠券
                    for(let val in data){
                        if(data[val].status=="AVAILABLE"){
                            if( (data[val].goodsList.indexOf(that.packageData.goodsId)>-1||data[val].goodsList.indexOf("ALL")>-1) && (((data[val].promotionMode=="P01"||data[val].promotionMode=="P02") && parseInt(total) >= data[val].fullCut*100)||data[val].promotionMode=="P03"||data[val].promotionMode=="P04") ){//可用的优惠码
                                that.couponDataList.availableList.push(data[val]);
                                // 默认选中点击的优惠券
                                if(selectedCoupon.promotionCode === data[val].promotionCode && !promotionData){
                                    that.couponDataList.selectedCoupon = data[val]
                                }

                                // P01：满减百分比;P02:满减金额;P03:直减百分比;P04:直减金额
                                // 如果没有点击优惠券，则默认选择最优优惠券
                                if(data[val].promotionMode =="P03"){
                                    if(selectedCouponOp?.promotionMode !== 'P03') selectedCouponOp = data[val];
                                    if(data[val].quota > selectedCouponOp?.quota) selectedCouponOp = data[val];
                                } else if(data[val].promotionMode =="P04") {
                                    if(!['P03','P04'].includes(selectedCouponOp?.promotionMode)) selectedCouponOp = data[val];
                                } else if(data[val].promotionMode =="P01") {
                                    if(!['P03','P04','P01'].includes(selectedCouponOp?.promotionMode)) selectedCouponOp = data[val];
                                } else if(data[val].promotionMode =="P02") {
                                    if(!['P03','P04','P01','P02'].includes(selectedCouponOp?.promotionMode)) selectedCouponOp = data[val];
                                }
                            }else{
                                that.couponDataList.unavailableList.push(data[val]);
                            }
                        }
                    }
                    that.couponDataList.couponText = that.couponDataList.availableList.length>0?(that.couponDataList.availableList.length+` ${that.$t('settlement_Not_used_coupon')}`):that.$t('settlement_No_coupon')
                    // 有默认选中优惠券则进行预计算
                    if(that.couponDataList.selectedCoupon?.promotionCode){
                        that.e_preCalcOrder();
                    } else if(!that.couponDataList.selectedCoupon?.promotionCode && selectedCouponOp?.promotionCode &&　!promotionData) {
                        that.couponDataList.selectedCoupon = selectedCouponOp;
                        that.e_preCalcOrder();
                    }
                },err=>{
                    that.$toast(err.resultDesc);
                })
            },
            CreateMethodToAutopayRegulation(payAgreeFlag){
                let that = this;
                this.e_preCalcOrder( payAgreeFlag );
            },
            getAjax(ajaxUrl,ajaxData){
                return this.$http.post(ajaxUrl, ajaxData);
            },
            //预计算价格，如果优惠后total=0则只能使用余额支付
            e_preCalcOrder( payAgreeFlag , Current_Chose_Promotion_actCode ){
                let that = this,da=that.packageData,pkgList = [];
                if( da.attrMap && (da.attrMap.expType=="USER_DEFINED"||da.attrMap.expType=="MAKE_APPOINTMENT"||da.attrMap.expType=="USER_DEFINED"||da.attrMap.expType=="MAKE_APPOINTMENT") ){
                    pkgList.push({"goodsId":da.goodsId,"quanity":that.urlParams.quantity,"effectiveTime":da.effectiveTime,"expireTime":da.expireTime})
                }else{
                    pkgList.push({"goodsId":da.goodsId,"quanity":that.urlParams.quantity})
                }
                let params = {
                    actCode:Current_Chose_Promotion_actCode,
                    userCode: JSON.parse(localStorage.getItem("userInfo"))['userCode'],
                    payCurrencyType: that.packageData.currencyType,
                    goodsList: pkgList,
                    promotionCode:that.couponDataList.selectedCoupon.promotionCode||"",
                    "payMethod": "ACCOUNT_AMOUNT",//that.currentPay.toUpperCase(),
                };
                if(payAgreeFlag){
                    params.payAgreeFlag = 1;
                }
                that.couponDataList.onlyUseBalance = false;
                that.$http.post(that.$api.preCalcOrder, params).then(d => {
                    if(d && d.data){
                        if(d.data.payPrice==0){
                            // that.selectPayment ("ACCOUNT_AMOUNT");
                            console.log('价格不能为0,没有余额支付');
                            that.couponDataList.onlyUseBalance = true;
                        }
                        let _payPrice= that.doPriceStyle(that.packageData.currencyType,d.data.payPrice)
                        that.$set(that.packageData,"priceStr",_payPrice);
                        that.$set(that.packageData,"actualPaymentAmount",d.data.payPrice);//记录优惠后的价格
                        // that.getPaymentList();
                        that.canUseBalance = false;
                        if(JSON.stringify(that.couponDataList.selectedCoupon)=="{}"){
                            that.couponDataList.couponText = that.couponDataList.availableList.length>0?(that.couponDataList.availableList.length+` ${that.$t('settlement_Not_used_coupon')}`):that.$t('settlement_No_coupon');
                        }else{
                            that.couponDataList.couponText = `<span ${this.isCurrencySymbol(that.packageData.currencyType) ? '' : "dir='ltr'"}>` +　"-"+that.doPriceStyle(that.packageData.currencyType,d.data.promotionDiscount) + "</span>";
                            // 记录优惠价格
                            that.$set(that.packageData,'promotionDiscount',d.data.promotionDiscount);
                        }
                        //如果有营销活动
                        //支付前确认使用优惠券还是营销活动
                        if(d.data && d.data.goodsList  && d.data.goodsList[0].mktInfo){
                            let _mktInfo = d.data.goodsList[0].mktInfo;
                            that.Promotion_use = _mktInfo.actCode;
                            that.Promotion_actName = _mktInfo.actName
                            if(_mktInfo.discount){
                                that.Promotion_use_discount = "- " + that.doPriceStyle(that.packageData.currencyType,_mktInfo.discount);
                            }
                        }else{
                            that.Promotion_use = '';
                            that.Promotion_use_discount = '';
                        }
                    }
                    
                },err=>{
                    that.$toast(err.resultDesc);
                    // that.$vux.toast.show({
                    //     text: err.resultDesc,
                    //     position: 'bottom',
                    //     type: 'text',
                    //     time: '2000'
                    // });
                })
            },
            doPriceStyle(currencyType, price) {                
                //price = keepTwodecimalFull(price/100);
                //return `${item.currencyType} ${price}`;
                return this.globalPriceFormat(currencyType, price);                
            },
            // 生成订单
            async createOrder(payMethod='ACCOUNT_AMOUNT', payAgreeFlag) {
                let orderObj = {},that = this,
                    channelType = that.$APP_CONFIG.request.channelType;
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                let params = {                    
                    channelType,
                    orderType: 'BUYPKG',
                    currencyType: this.packageData.currencyType,
                    goodsList: [{
                        goodsId: this.packageData.goodsId,
                        quanity: this.urlParams.quantity,
                        effectiveTime: 0,
                        expireTime: 0
                    }],
                    buyImei:autopayRegulation.currentIMEI_imei,
                    orderMark: '',
                    payMethod,
                    payAgreeFlag: payAgreeFlag&&1 || 0
                };

                //连续包月订购功能
                if(payAgreeFlag){
                    params.payAgreeFlag = 1;
                }

                 // 使用优惠券
                if(JSON.stringify(that.couponDataList.selectedCoupon)!="{}"){
                    params.promotionCode = that.couponDataList.selectedCoupon.promotionCode;
                    params.promotionInstId = that.couponDataList.selectedCoupon.id;
                }

                //有营销活动 并使用
                if(that.Promotion_use){
                    params.actCode = that.Promotion_use;
                }

                // 为家庭组下的生成订单
                if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
                    params.imei = JSON.parse(sessionStorage.getItem('urlData') || '{}')?.imei;
                    delete params.buyImei;
                }

                // sn登录，未用imei登录，创建订单使用sn
                if(urlData.sn){
                    params.userCode = urlData.userCode;
                    delete params.buyImei;
                }
                
                await this.$http.post({
                    url: '/bss/app/order/CreateOrder',
                    data: {
                        ...params
                    }
                }).then(res => {
                    if(res.data && res.data.orderSN) {
                        orderObj = res.data;
                        // 如果创建订单一些数据没有拿到则返回
                        if(!orderObj.orderSN) {
                            this.$toast(this.$t('packages.confirm.create_order_error'));
                        }else{
                            that.getOrderInfo(orderObj,payAgreeFlag&&'CYCLE'||'PAY');    
                        }
                        
                    }
                }).catch(err => {                    
                    this.$toast(err);
                });

                return orderObj;
            },
            async onlinePayment() {
                // 先要生成订单
                //只有在线支付 -- PAYONLINE，没有余额支付 --- ACCOUNT_AMOUNT
                let orderData,payFunction,checkPay,type="PAYONLINE";

                //是否是周期扣款
                if(!autopayRegulation.CurrentPackageStatusISLXCX){

                    payFunction = 'PAY'
                    orderData = this.createOrder(type);

                }else{
                    //周期扣款
                    payFunction = 'CYCLE';
                    orderData = autopayRegulation._RechargePaymentAccess(type);
                }

                let params = {
                    order_amount:AmountHelper.multiply(this.packageData.goodsPrice, this.urlParams.quantity) / 100,
                    order_actual_amount:this.packageData.actualPaymentAmount / 100,
                    data_package_code:this.packageData.goodsCode,
                    data_package_name:this.packageData.goodsName,
                    monetary_unit:this.packageData.currencyType,
                    effective_days_num:this.packageData.periodUnit === 'DAY' ? +this.packageData.period : +this.packageData.period * 30,
                    data_num:this.packageData.flowByte,
                }

                if(this.couponDataList?.selectedCoupon?.promotionCode){
                    params = {
                        ...params,
                        coupon_id:this.couponDataList.selectedCoupon.promotionId,
                        coupon_name:this.couponDataList.selectedCoupon.promotionName['zh-CN'] || this.couponDataList.selectedCoupon.promotionName,
                        coupon_amount:this.packageData.promotionDiscount / 100,
                        coupon_code:this.couponDataList.selectedCoupon.promotionCode,
                    }
                }
                
                // 神策-点击在线支付
                this.$sensors.track('WebDataPackagePayClick', {
                    ...params,
                });
            },
            getOrderInfo(orderData,payFunction){
                //国家维度自定义收银台支付模板
                let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                let countryCode = sessionStorage_UrlData.registerCountry|| 
                                    this.$projectConfig.registerCountry||
                                    sessionStorage_UrlData.placeCode||'';
                // 去收银台支付
                payFun({
                    orderSn: orderData.orderSN,
                    totalAmount: orderData.amount,
                    currencyCode: this.packageData.currencyType,
                    orderDesc: this.packageData.goodsName,
                    orderSubject: this.packageData.goodsName,
                    payFunction:payFunction,
                    countryCode:countryCode,
                });
            },
            //打开优惠券弹框
            e_openCouponDialog(){
                let that = this;
                // if(that.couponDataList.availableList.length==0) return ;//无可用优惠券时点击不打开弹框
                that.status.showCouponPopup = true;
                that.status.comCoupon = true;
                that.couponDataList.publicValid = true;
                that.couponDataList.publicTips = "";
                // that.stopMove();
            },
            //关闭优惠券弹框
            e_hideCouponDialog(){
                this.status.showCouponPopup = false;
                // this.Move();
                setTimeout(() => {
                    this.status.comCoupon = false;
                }, 500);
            },
            //停止页面滚动
            stopMove(){
                document.body.className='popup-hidden';
            },
            //开启页面滚动
            Move(){
                document.body.className='';
            },
             //已选中优惠券
            e_selectCoupon(d,type){
                let that = this;
                if(type=="private"){
                    that.couponDataList.selectedCoupon = d;
                    that.e_preCalcOrder();
                }else{
                    if(JSON.stringify(d)=="{}") {
                        that.couponDataList.selectedCoupon = {};
                        that.e_preCalcOrder();
                        return;
                    }
                    that.e_queryPublicPromotionInfo(d);
                }
            },
            //查询公共促销码是否可用
            e_queryPublicPromotionInfo(code){
                let that = this;
                var params = {
                    "promotionCode":code||"",
                    "goodsList":[that.packageData.goodsId],
                };
                that.$http.post(that.$api.queryPromotionInfo, params).then(d => {
                    that.couponDataList.selectedCoupon = {
                        "promotionCode":d.data.promotionCode,
                        "promotionName":d.data.promotionName,
                        "promotionId":d.data.id,
                    }
                    that.e_preCalcOrder();
                    setTimeout(() => {
                        that.e_hideCouponDialog();
                    }, 300);
                },err=>{
                    that.couponDataList.publicValid = false;
                    that.couponDataList.publicTips = err.resultDesc;
                })
            },
            // 判断是否使用了货币符号
            isCurrencySymbol(price='') {
                let typeList = [];
                if(this.$APP_CONFIG.currencyTypeMap) {
                    typeList = Object.keys(this.$APP_CONFIG.currencyTypeMap);
                }
                return typeList.some(item => {
                    return price?.toLowerCase()?.includes(item) && this.$APP_CONFIG.currencyTypeMap[item];
                })
            },
        }
    }
</script>

<style lang="less">
    @import 'css/confirm.less';
    @assets: "../../assets";
    .Contract_recommendation{background: #fff5e5 url("@{assets}/imgs/packages/lxcxBg.svg") no-repeat right top;}
</style>
<style>
    .popup-hidden {
        /*overflow: hidden;*/
    }
    .package-buy-confrim .van-popup__close-icon{
        font-size: .42rem;
    }
    .package-buy-confrim .van-popup__close-icon--top-right{
        top: .22rem;
        right: .32rem;
    }
    .position_top_icon{position: relative;margin-left: 0.14rem}
    .mb8{margin-bottom: 18px;}
    .mb_8{margin-bottom: 8px;}
    .bgfff{background: #fff;}
    .settlement {margin-top: 0.96rem;}
    .settlement .se_back {width: 0.22rem;padding: 0.28rem 0.36rem;}
    /*.settlement_box {padding: 0.6rem 0.36rem 0;}*/
    .settlement_box .settlement_title {font-size: 0.42rem;color: #333;font-weight: 600;margin-bottom: 12px;}
    
    .noBind .title, .selectBind .title {font-size: 0.28rem;color: #333;font-weight: 600;margin-top: 0.46rem;}
    .noBind .btn_bind {width: 6.22rem;height: 0.84rem;line-height: 0.84rem;background: #1CA64A;border-radius: 8px;font-size: 0.28rem;color: #fff;display: block;margin: 0.48rem auto;}
    .selectBind .device_selected {border: 1px solid #E3E3E3;border-radius: 4px;margin-top: 0.22rem;padding: 0.2rem 0.32rem;}
    .selectBind .device_selected:after {content: '';display: inline-block;border-style: solid;border-color: transparent transparent #ccc transparent;border-width: 0.2rem;position: absolute;top: 0.5rem;right: 0.3rem;transition: all 0.3s ease 0s;}
    .selectBind .device_selected.unfold:after {transform: rotate(180deg);top: 0.5rem;transition: all 0.3s ease 0s;}
    .selectBind .device_selected.required {background: rgba(255,103,9,0.04);border: 1px solid #ff6709;color: #ff6709;}
    .selectBind .device_selected .noSelect {padding: 0.16rem 0;}
    .device_selected .selected_name {color: #333;font-size: 0.28rem;margin-bottom: 0.1rem;}
    .device_selected .selected_imei {color: #999;font-weight: 600;font-size: 0.2rem;}
    .select_box .required_tips {font-size: 0.28rem;color: #ff6709;position: absolute;top: 1.2rem;left: 0.2rem;}
    .noBind, .select_box {position: relative;}
    .noBind {margin-bottom: 0.48rem;}
    .selectBind {margin-bottom: 2.5rem;}
    .noBind .required_tips {font-size: 0.28rem;color: #ff6709;position: absolute;top: 1.8rem;left: 0.2rem;}
    .bind_device_list {position: absolute;width: 100%;top: 1.3rem;box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);border-radius: 4px;padding: 0 0.32rem 0.2rem;box-sizing: border-box;background: #fff;z-index: 10;max-height: 3.5rem;overflow: auto;}
    .bind_device_list:before {content: '';display: inline-block;width: 0.3rem;height: 0.3rem;border-style: solid;border-color: rgba(0,0,0,0.08);border-width: 0;transform: rotate(-45deg);position: absolute;top: -0.1rem;right: 0.35rem;box-shadow: 2px -2px 10px 0 rgba(0,0,0,0.08);background: #fff;}
    .bind_device_list li {position: relative;border-bottom: 1px solid #E3E3E3;padding: 0.2rem 0;}
    .bind_device_list li.disabled {cursor: no-drop;}
    .bind_device_list li .device_name {color: #333;font-size: 0.28rem;margin-bottom: 0.1rem;}
    .bind_device_list li .device_imei {color: #999;font-weight: 600;font-size: 0.2rem;}
    .bind_device_list li.disabled .device_name, .bind_device_list li.disabled .device_imei {color: #ccc;}
    .bind_device_list li .icon {display: block;position: absolute;width: 0.4rem;height: 0.4rem;border-radius: 50%;right: 0;top: 0.32rem;border: 1px solid #e0e0e0;}
    .bind_device_list li .selected {background: #1CA64A;border-color: transparent;}
    .bind_device_list li .selected:after {content: '';width: 0.1rem;height: 0.18rem;display: block;border-style: solid;border-color: #fff;border-width: 0 2px 2px 0;transform: rotate(45deg);position: absolute;right: 0.12rem;top: 0.05rem;}

    .settlement_payment_list .title {font-size: 0.36rem;color: #333;font-weight: 600;margin-bottom: 0.28rem;}
    .payment_item {width: 100%;height: 0.84rem;line-height: 0.84rem;border: 1px solid #e3e3e3;border-radius: 6px;margin-bottom: 0.24rem;text-align: center;box-sizing: border-box;}
    .payment_item.noclick{pointer-events: none;background: #f3f4f9;}
    .payment_item .inner_border {border: 1px solid transparent;}
    .payment_item:hover {border: 2px solid #32AE5B;box-sizing: border-box;}
    .payment_item:hover .inner_border {border: none;}
    .payment_item.selected .inner_border {border: none;}
    .payment_item.selected {background: rgba(28,166,74,0.08);border: 2px solid #1CA64A;box-sizing: border-box;}
    .payment_item .icon {width: 0.6rem;height: 0.6rem;display: inline-block;background-size: contain;margin: 0 0.1rem 0.1rem;vertical-align: middle;}
    .payment_item .balance {font-size: 0.28rem;font-weight: 600;}
    .payment_item.opacity {opacity: 0.5;}
    .payment_item label {font-size: 0.28rem;color: #333;font-weight: 600;}

    /*.settlement_summary {margin-top: 0.48rem;margin-bottom: 0.72rem;}*/
    .settlement_summary {margin-bottom: 0.28rem;}
    .settlement_summary .title {font-size: 0.36rem;color: #333;margin-bottom: 0.28rem;font-weight: 600;}
    .summary .inner {/*border-radius: 6px;*//*padding: 0.28rem 0.28rem 0.64rem;*/}
    .summary .inner_padding {padding: 0.28rem 0.42rem 0;}
    .summary .inner_total_padding {margin-left: 0.42rem;padding:0.42rem 0.42rem 0.42rem 0;border: 1px solid #e3e3e3;border-width: 1px 0 0 0;}
    
    .summary .summary_detail{background: #fff;margin-bottom: 8px;}
    .summary .summary_content .inner_padding {padding: 0.42rem;}
    .summary_footer {margin-top: 8px;}
    .summary_item {font-size: 0.28rem;color: #333;padding: 0.2rem 0;}
    .summary_item {font-size: 0.4rem;}
    .summary_item .package_name {/*max-width: 70%;*/display: inline-block;word-break: break-word;font-weight: 600;margin-bottom: 8px;font-size: 16px;line-height: 22px}
    .summary_item .package_num_icon img {width: 0.32rem;vertical-align: middle;}
    .summary_item .package_num {margin-left: 0.2rem;color: #999}
    .summary_item .package_price {text-align: right;margin-top: 0.05rem;}
    .summary_item .package_price .price {color: #666}
    .summary_item .package_subTotal {color: #666}
    /*.summary_item .package_subTotal_title {font-weight: 600;}*/
    /*.summary_item .package_coupon_title {font-weight: 600;}*/
    .summary_item .package_coupon_title,.package_subTotal_title{color:#060606 }
    .summary_item .coupon_more {font-size: 0.3rem;color: #DBDBDB;}
    .summary_item .coupon_canuse {font-size: 0.32rem;color: #FF6709;}
    .summary_item .coupon_cantuse {font-size: 0.40rem;color: #999;}
    .summary .summary_total {margin-top: 0.32rem;height: 0.8rem;line-height: 0.8rem;margin-bottom: 0.32rem;text-align: right;}
    .summary .summary_total label {font-size: 0.24rem;margin-right: 0.6rem;}
    .summary .fee {color: #333;font-size: 0.48rem;font-weight: bold;display: block;}
    .summary .summary_policy {line-height: 0.35rem;display: inline-block;font-size: 0.24rem;color: #666;margin-bottom: 0.4rem;}
    .summary .summary_policy a {color: #0371E3;}
    .summary .buy {width: 100%;height: 0.84rem;line-height: 0.84rem;background: #1CA64A;border-radius: 8px;font-size: 0.28rem;color: #fff;}

    .bind_device_fixed {position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,0.50);z-index: 1000;}
    .bind_device_box {width: 100%;background: #fff;position: absolute;bottom: 0;border-radius: 12px 12px 0 0;}
    .bind_device_box .title {padding-top: 0.64rem;text-align: center;font-size: 0.32rem;color: #333333;font-weight: 500;}
    .bind_device_box .subTitle {padding: 0.3rem 0;text-align: center;font-size: 0.24rem;color: #666;font-weight: normal;}
    .bind_device_form input {width: 100%;height: 1.12rem;box-sizing: border-box;padding-left: 0.32rem;border: none;border-top: 1px solid #e0e0e0;color: #333;}
    .bind_device_box .btn {width: 50%;height: 1.12rem;font-size: 0.32rem;color: #666;cursor: pointer;}

    .bind_again_tips {position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,0.50);z-index: 1000;}
    .bind_again_box {width: 100%;background: #fff;position: absolute;bottom: 0;border-radius: 12px 12px 0 0;}
    .bind_again_box .title {padding: 0.64rem 0.26rem 0.32rem;text-align: center;font-size: 0.32rem;color: #333333;}
    .bind_again_box .btn {width: 50%;height: 1.12rem;font-size: 0.32rem;color: #666;cursor: pointer;}

    .stripe_icon_box {height: 0.6rem;line-height: 0.6rem;}



    .summary .buy ,.summary .onlinebuy ,.summary .balanceBuy {width: 100%;height: 0.84rem;line-height: 0.84rem;background: #1CA64A;border-radius: 4px;font-size: 0.28rem;color: #fff;cursor: pointer;}
    .summary .balanceBuy{border:1px solid #1CA64A;background: #fff;color: #1CA64A;}
    .summary .onlinebuy,.summary .balanceBuy {font-size: 0.28rem;margin-bottom: 0.4rem;}
    .summary .balanceBuy .balance{font-size: 0.12rem;}
    .summary button img{height: 0.38rem; margin-right: 0.2rem; vertical-align: sub;}

    /* #payAgreeSymbol_wrap  */
    .payAgreeSymbol{display: none;font-size: 0.20rem;color:#333;background: #fff;padding:0 0.42rem;margin-bottom: 8px;overflow: hidden;}

    .payAgreeSymbol_wrap .settlement_title {margin-bottom: 0.4rem;color: #333}
    .payAgreeSymbol_wrap .payAgreeSymbol{display: block;}

    .sale_Promotion{font-size: 0.28rem;color:#999;margin-bottom: 0.38rem;}
    .anyTime_Buy{color:#FF6709;}
    ul.Sale_Portal {width:100%;overflow: hidden;margin-bottom: 0.2rem;}
    ul.Sale_Portal li{float: left;height:2.5rem;text-align: center;width: 33%;padding-top: .2rem;}
    ul.Sale_Portal li img{width:1rem; margin-bottom: .24rem;}
    ul.Sale_Portal li p{font-size: .26rem;}
    ul.Sale_Portal li .line{border: 1px solid #E0E0E0; border-width: 0 1px;}
    .payAgreeSymbol_wrap_agreement{padding: 0.42rem 0;border-top:1px solid #E0E0E0;font-size: .4rem;color: #666}
    .payAgreeSymbol_wrap_agreement p {text-align: center;}
    .payAgreeSymbol_wrap_agreement a{color:#6BBC46;}
    .payAgreeSymbol_wrap_agreement a:hover{color:#6bb04d}

    .summaryBg{background: #F5F5F5;}
    .summary_list{overflow: hidden;}
    .payAgreeSymbol_wrap .summary_list.summary_list_coupon{display: none;}
    .summary .border_none{border:0;}
    .summary .border_bottom{border-bottom: 1px solid #e3e3e3;}
    .payAgreeSymbol_wrap .none{display: none;}

    .GeneralPackageHasLxcx{border-bottom: 0 none;padding:0.21rem 0.14rem;display: none;}
    
    .Contract_recommendation{border:1px solid rgba(255,179,50,40); border-radius: 5px;padding:.28rem;}
    .Contract_recommendation label{font-size: .42rem; color:#333;display: inline-block;line-height: .36rem;font-weight: 600;}
    .Contract_recommendation p.money{font-size: .72rem; color:#FF6709;display: block;padding: 0.24rem 0;}
    .Contract_recommendation p.SubscribeTips{font-size: .28rem; color:#666;padding-right:2.8rem;position: relative;}
    .Contract_recommendation a.btn{font-size: .4rem;color:#999;position: absolute;right: 0;top:6px;}

    .weui-dialog__bd{word-break: break-word;}

    .bind_device_list li a.AddDevice{border-bottom: 0 none;padding:0;text-align: center;color:#333;display: block;cursor: pointer;}
    .bind_device_list li:hover a.AddDevice{color:#1CA64A}

    .pay-res-popup{border-top-left-radius: .12rem;border-top-right-radius: .12rem;}
    .pay-res-wrap{position: relative;background: #ffffff;}
    .pay-res-tit{height: 1.86rem;display: flex;align-items: center;padding: 0 .32rem;justify-content: center; font-size: .32rem;border-top-left-radius: .12rem;border-top-right-radius: .12rem;}
    .pay-res-cont{border-top: 1px solid #ccc;display: flex;background: #f5f5f5;}
    .pay-res-btn-l,.pay-res-btn-r{position: relative; flex: 1;font-size: .28rem;text-align: center;height: 1.12rem;line-height: 1.12rem;}
    .pay-res-btn-r::before{position: absolute;content: '';height: .34rem;width: 1px;background: #ccc;left: 0;top: .39rem;}
    .color_FFB242{color: #FFB242;padding-top: 8px;}
    .summary_item .color_F74E4E{color: #F74E4E}
</style>

<style lang="less" scoped>
    html[dir="rtl"] .package-buy-confrim {
        .summary {
            .summary_detail {
                .summary_item {
                    .summary_list {
                        .package_num_icon {
                            .fl {
                                float: right;
                                .package_num {
                                    margin-left: 0;
                                    margin-right: 0.2rem;
                                }
                            }
                            .package_price {
                                text-align: left;
                            }
                        }
                        .package_subTotal {
                            float: left;
                        }
                    }
                }
            }
            .summary_content {
                .summary_item {
                    .summary_list {
                        .coupon_select {
                            float: left;
                        }
                        .package_subTotal {
                            float: left;
                        }
                    }
                }
            }
        }
        .icon_popup {
            ::v-deep .van-icon.van-popup__close-icon--top-right {
                right: unset;
                left: 0.444444rem;
            }
        }
        .payment-btn {
            .online-payment {
                padding-left: unset;
                padding-right: 36px;
            }
            .online-payment::before {
                left: unset;
                right: 0;
            }
    }
    }
</style>